import { render, staticRenderFns } from "./app-layout.vue?vue&type=template&id=4cf7187c&"
import script from "./app-layout.vue?vue&type=script&lang=js&"
export * from "./app-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports